import { Badge } from '@adop/ui';
import type { BadgeVariant } from '@adop/ui';
import { orderStatusTone, paymentStatusTone, reservationStatusTone } from '../lib/order-actions';
import { humanize } from '../lib/format';

function toVariant(tone: string): BadgeVariant {
  return tone as BadgeVariant;
}

export function OrderStatusBadge({ status }: { status: string }) {
  return <Badge variant={toVariant(orderStatusTone(status))}>{humanize(status)}</Badge>;
}

export function PaymentStatusBadge({ status }: { status: string }) {
  return <Badge variant={toVariant(paymentStatusTone(status))}>{humanize(status)}</Badge>;
}

export function ReservationStatusBadge({ status }: { status: string }) {
  return <Badge variant={toVariant(reservationStatusTone(status))}>{humanize(status)}</Badge>;
}

export function RoleBadge({ role }: { role: string }) {
  const variant: BadgeVariant =
    role === 'owner' ? 'success' : role === 'manager' ? 'info' : 'default';
  return <Badge variant={variant}>{humanize(role)}</Badge>;
}
